/* eslint-disable react/no-typos */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

const defaultState = {
    type: "button",
    onClick:PropTypes?.func
};
const ButtonPage = ( props = defaultState ) => {
    return (
        <Button type={props?.type} onClick={props.onClick} className={`btn-common ${props?.className}`}>
            {props?.Text}
        </Button>
    );
}
ButtonPage.propTypes ={
    onClick:PropTypes.func,
    leftIcon:PropTypes.any,
    Text:PropTypes.any,
    className:PropTypes.any,
    rightIcon:PropTypes.any,
    type:PropTypes.string
}
export default ButtonPage;
